import React from 'react'
import GenericError from '../Generic'

const Component = () => {
  return <GenericError title="500 Internal Server Error" description="エラーにより表示できません" />
}

export default Component
